import { _ as _applyDecoratedDescriptor, a as _initializerDefineProperty } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Service, { inject } from '@ember/service';
import { set } from '@ember/object';
import { tracked } from '@glimmer/tracking';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4;

/**
 * Servizio Document Sign
 * Gestisce lo stato e l'evento di fine firma documento.
 * Estratto dal god-controller application (maintainability 4.2), comportamento invariato.
 */
let DocumentSignService = (_class = class DocumentSignService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "notify", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "signRunning", _descriptor3, this);
    _initializerDefineProperty(this, "reloadPrivacy", _descriptor4, this);
  }
  /**
   * Gestisce l'evento di fine firma documento
   * @param {Object} data - Dati della firma completata
   */
  handleDocumentSignEnd(data) {
    if (!this.signRunning || !data?.device_id) {
      return;
    }
    const attrs = data.value?.attributes;
    const fileName = attrs?.file_name;
    if (!fileName || !attrs?.file_url) {
      return;
    }
    this.signRunning.forEach(sign => {
      if (fileName.includes(sign.file_name) && parseInt(data.device_id) === parseInt(sign.device.id)) {
        this.reloadPrivacy = !this.reloadPrivacy;
        this.notify.success(this.intl.t('document signed!'));
        set(sign, 'success', true);
        set(sign, 'document_sign_end', data);
      }
    });
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "notify", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [inject], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "signRunning", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "reloadPrivacy", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);

export { DocumentSignService as default };
//# sourceMappingURL=document-sign.js.map
